import { render } from "./MailForm.vue?vue&type=template&id=b21fc128&ts=true"
import script from "./MailForm.vue?vue&type=script&lang=ts"
export * from "./MailForm.vue?vue&type=script&lang=ts"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__